import { PencilCircleOutlineIcon } from './PencilCircleOutlineIcon';

/**
 * author: Austin Andrews
 * id 5D68DE43-969F-40BE-8A2D-F5C25F2B0853
 * name pencil-circle-outline
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-circle-outline.svg
 * tags
 * - Drawing / Art 
 */
export const EditCircleOutlineIcon = PencilCircleOutlineIcon;
export default EditCircleOutlineIcon